import type { DataContainer } from "@otto-ec/tracking-bct";

export type Detailview = {
	benefitId: string;
	activeUntil: string;
	variationId: string;
	activationStatus: ActivationStatus;
	tracking: Tracking;
	isAppOnly: boolean;
};

export class Tracking {
	constructor(
		readonly id: string,
		readonly name: string,
		readonly labels: DataContainer,
	) {}
}

export enum ActivationStatus {
	DEACTIVATED = "DEACTIVATED",
	ACTIVATED = "ACTIVATED",
}
